import en from "./i18n-en-pci-Data"

// en, de, fr, pt
export default {
    en,
}
